import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import Settings from '@mui/icons-material/Settings';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Navigation } from '@src/routing/Navigation';
import { useTranslation } from 'react-i18next';

import { SideNav, SideNavLink } from './SideNav';

export const UsersSideNav = () => {
  const { t } = useTranslation();
  const iconSize = 26;

  return (
    <SideNav
      additionalSettings={
        <>
          <SideNavLink
            icon={<Settings style={{ width: iconSize, height: iconSize }} />}
            to={Navigation.settings.PATH}
            children={undefined}
          />
        </>
      }
    >
      <SideNavLink
        icon={
          <TaskOutlinedIcon style={{ width: iconSize, height: iconSize }} />
        }
        to="/"
      >
        {t('orders.title')}
      </SideNavLink>
      <SideNavLink
        icon={<SavedSearchIcon style={{ width: iconSize, height: iconSize }} />}
        to={Navigation.permitSearch}
      >
        {t('permitSearch.navigationName')}
      </SideNavLink>
      <SideNavLink
        icon={<WorkOutlineIcon style={{ width: iconSize, height: iconSize }} />}
        to="/clients"
      >
        {t('clients')}
      </SideNavLink>
      <SideNavLink
        icon={
          <PeopleOutlinedIcon style={{ width: iconSize, height: iconSize }} />
        }
        to="/users"
      >
        {t('users')}
      </SideNavLink>
      <SideNavLink
        icon={
          <ReceiptLongOutlinedIcon
            style={{ width: iconSize, height: iconSize }}
          />
        }
        to={Navigation.reports}
      >
        {t('reports')}
      </SideNavLink>
    </SideNav>
  );
};
